import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WsNotification } from "@/dto/notifications/response/NotificationResponse.d";

interface NotificationBellState {
  /** Incremented for every WS message while the drawer is closed */
  wsUnreadCount: number;
  /** Notifications that arrived via WebSocket (shown at the top of the list) */
  realtimeNotifications: WsNotification[];
}

const initialState: NotificationBellState = {
  wsUnreadCount: 0,
  realtimeNotifications: [],
};

const notificationBellSlice = createSlice({
  name: "notificationBell",
  initialState,
  reducers: {
    addWsNotification(state, action: PayloadAction<WsNotification>) {
      state.wsUnreadCount += 1;
      state.realtimeNotifications.unshift(action.payload);
    },
    resetWsUnreadCount(state) {
      state.wsUnreadCount = 0;
    },
    clearRealtimeNotifications(state) {
      state.realtimeNotifications = [];
    },
  },
});

export const {
  addWsNotification,
  resetWsUnreadCount,
  clearRealtimeNotifications,
} = notificationBellSlice.actions;

export default notificationBellSlice.reducer;
